// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sQ-z","hovered":"tQ-z","hoverImage":"uQ-z","mainImage":"vQ-z","imageNoBackground":"wQ-z","fullSizeImage":"xQ-z"};